import React, {PropTypes} from 'react';

import SingleButton from './SingleButton';
import SingleButtonBlock from './SingleButtonBlock';
import BlockSelect from './BlockSelect';

const INLINE_STYLES = [{
    label: 'Align Left',
    style: "ALIGN_LEFT",
    value: "left",
    disabled: false
}, {
    label: 'Align Center',
    style: "ALIGN_CENTER",
    value: "center",
    disabled: false
}, {
    label: 'Align Right',
    style: "ALIGN_RIGHT",
    value: "right",
    disabled: false
}, {
    label: 'Justify',
    style: "JUSTIFY",
    value: "justify",
    disabled: false
}];

const BLOCK_TYPES = [{
    label: 'Bullet list',
    value: 'unordered-list-item',
    disabled: false
}, {
    label: 'Ordered list',
    value: 'ordered-list-item',
    disabled: false
},];

const BottomTools = (props)=> {
    const {editorState} = props;
    const selection = editorState.getSelection();
    const block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
    const blockType = block.getType();
    const blockAlignment = block.getData().get('textAlignment');

    return (
    <div className="richutils__bottom">
        {INLINE_STYLES.map(inline=> {
            return (
            <SingleButton key={inline.label}
                          label={inline.label}
                          style={inline.style}
                          active={blockAlignment === inline.value}
                          onToggle={()=>props.onAlignmentChange(inline.value)}
                          disabled={inline.disabled}/>
            )
        })}
        {BLOCK_TYPES.map(block=> {
            return (
            <SingleButtonBlock value={block.value}
                               label={block.label}
                               disabled={block.disabled}
                               onToggle={props.onToggleBlock}
                               active={blockType === block.value}
                               key={block.value}
            />
            )
        })}

    </div>
    )
}
//
// <BlockSelect onToggle={()=>{console.log('toggled')}} options={FONT_SIZES["header-one"]} disabled={false}
//               blockType={'12pt'}/>

export default BottomTools;


// WEBPACK FOOTER //
// ./src/_app/estimations/editor/tools/RichUtils/BottomTools.js